import script from "./PCPartsItemCardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsItemCardHeader.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsItemCardHeader.vue?vue&type=style&index=0&id=0b26ab69&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b26ab69"]])

export default __exports__